const REGISTER_PAGE = {
  en: {
    navbar: {
      appName: "TA Connect",
      login: "Login",
    },
    heading: {
      title: "Create Account",
      subtitle: "Join TA Connect and start scheduling office hours",
    },
    form: {
      firstName: "First Name",
      firstNamePlaceholder: "Enter your first name",
      lastName: "Last Name",
      lastNamePlaceholder: "Enter your last name",
      username: "Username",
      usernamePlaceholder: "Choose a username",
      email: "Email Address",
      emailPlaceholder: "Enter your email",
      password: "Password",
      passwordPlaceholder: "Create a password",
      confirmPassword: "Confirm Password",
      confirmPasswordPlaceholder: "Re-enter your password",
      userType: "I am a",
      userTypeStudent: "Student",
      userTypeInstructor: "Teaching Assistant",
      registerButton: "Create Account",
      registeringButton: "Creating Account...",
    },
    validation: {
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      usernameRequired: "Username is required",
      emailRequired: "Email is required",
      invalidEmail: "Please enter a valid email address",
      passwordRequired: "Password is required",
      passwordMinLength: "Password must be at least 8 characters",
      passwordUppercase: "Password must contain at least one uppercase letter",
      passwordLowercase: "Password must contain at least one lowercase letter",
      passwordNumber: "Password must contain at least one number",
      confirmPasswordRequired: "Please confirm your password",
      passwordsDoNotMatch: "Passwords do not match",
      userTypeRequired: "Please select your user type",
    },
    messages: {
      success: "Account created successfully! Please check your email to verify your account.",
      successSubtext: "We've sent a verification link to your email address. Click the link to activate your account.",
      checkSpam: "Check your spam folder if you don't see the email.",
      goToLogin: "Go to Login",
      error: "Failed to create account. Please try again.",
    },
    footer: {
      haveAccount: "Already have an account?",
      loginLink: "Login here",
    },
  },
  ar: {
    navbar: {
      appName: "TA Connect",
      login: "تسجيل الدخول",
    },
    heading: {
      title: "إنشاء حساب",
      subtitle: "انضم إلى TA Connect وابدأ في جدولة الساعات المكتبية",
    },
    form: {
      firstName: "الاسم الأول",
      firstNamePlaceholder: "أدخل اسمك الأول",
      lastName: "اسم العائلة",
      lastNamePlaceholder: "أدخل اسم العائلة",
      username: "اسم المستخدم",
      usernamePlaceholder: "اختر اسم مستخدم",
      email: "البريد الإلكتروني",
      emailPlaceholder: "أدخل بريدك الإلكتروني",
      password: "كلمة المرور",
      passwordPlaceholder: "أنشئ كلمة مرور",
      confirmPassword: "تأكيد كلمة المرور",
      confirmPasswordPlaceholder: "أعد إدخال كلمة المرور",
      userType: "أنا",
      userTypeStudent: "طالب",
      userTypeInstructor: "معيد",
      registerButton: "إنشاء حساب",
      registeringButton: "جاري إنشاء الحساب...",
    },
    validation: {
      firstNameRequired: "الاسم الأول مطلوب",
      lastNameRequired: "اسم العائلة مطلوب",
      usernameRequired: "اسم المستخدم مطلوب",
      emailRequired: "البريد الإلكتروني مطلوب",
      invalidEmail: "الرجاء إدخال عنوان بريد إلكتروني صالح",
      passwordRequired: "كلمة المرور مطلوبة",
      passwordMinLength: "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
      passwordUppercase: "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل",
      passwordLowercase: "يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل",
      passwordNumber: "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل",
      confirmPasswordRequired: "الرجاء تأكيد كلمة المرور",
      passwordsDoNotMatch: "كلمتا المرور غير متطابقتين",
      userTypeRequired: "الرجاء اختيار نوع المستخدم",
    },
    messages: {
      success: "تم إنشاء الحساب بنجاح! يرجى التحقق من بريدك الإلكتروني للتحقق من حسابك.",
      successSubtext: "لقد أرسلنا رابط التحقق إلى بريدك الإلكتروني. انقر على الرابط لتفعيل حسابك.",
      checkSpam: "تحقق من مجلد الرسائل غير المرغوب فيها إذا لم تجد البريد الإلكتروني.",
      goToLogin: "انتقل إلى تسجيل الدخول",
      error: "فشل إنشاء الحساب. الرجاء المحاولة مرة أخرى.",
    },
    footer: {
      haveAccount: "هل لديك حساب بالفعل؟",
      loginLink: "سجّل الدخول هنا",
    },
  }
};

export default REGISTER_PAGE;
